import { render, staticRenderFns } from "./PlantillasTable.vue?vue&type=template&id=4aac1692&lang=pug&"
import script from "./PlantillasTable.vue?vue&type=script&lang=js&"
export * from "./PlantillasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports